import { Alert, Box, Button, Card, Checkbox, Container, FormControlLabel, Link, TextField, Typography } from "@mui/material";
import { Warning } from "@mui/icons-material";
import { useState } from "react";
import { SignInModel } from "../models/SignInModel";
import { Persistence, WebStorageService } from "../services/WebStorageService";
import { CURRENT_USER } from "../contants/constants";
import { Utils } from "../helpers/utils";
import { useNavigate } from "react-router-dom";
import { PartnerService } from "../services/PartnerService";
import { Helper } from "../services/Helper";

export default function SignIn() {
    const [hasError, setHasError] = useState(false);
    const [message, setMessage] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [rememberMe, setRememberMe] = useState(true);
    const navigate = useNavigate();

    const [model, setModel] = useState(new SignInModel());
    const webStorageService = new WebStorageService();

    function onSignIn() {
        Helper.toSHA256(password).then(hashedPassword => {
            new PartnerService().SignIn({ Username: username, Password: hashedPassword, RememberMe: rememberMe }).then(response => {
                setHasError(!response.IsSuccessful);
                if (response.IsSuccessful) {
                    webStorageService.setJson(CURRENT_USER, response.Data, rememberMe ? Persistence.UnlessCleared : Persistence.UnlessClosed);
                    navigate("/my-dashboard")
                } else {
                    setMessage(response.Message)
                }
            })
        })
    }

    return (
        <Container>
            <Card sx={{ marginTop: 15, padding: 2, marginX: "auto", maxWidth: 400, boxShadow: { xs: 'none', md: 'var(--Paper-shadow)' } }}>
                <Typography variant="h4" sx={{ marginBottom: 4 }}>
                    Marketing Partner Sign in
                </Typography>
                <Typography variant="subtitle2" sx={{ marginBottom: 4 }}>
                    Please enter your registered phone number and password to sign in.
                </Typography>
                <Box sx={{ marginBottom: 4 }}>
                    <TextField label="Username" placeholder="Your registered phone number" variant="outlined" fullWidth={true} value={username} onChange={e => setUsername(e.target.value)}></TextField>
                </Box>
                <Box sx={{ marginBottom: 4 }}>
                    <TextField label="Password" variant="outlined" fullWidth={true} value={password} onChange={e => setPassword(e.target.value)} type="password"></TextField>

                </Box>
                <FormControlLabel sx={{ marginBottom: 4 }} control={<Checkbox defaultChecked={rememberMe} onChange={e => setRememberMe(e.target.checked)} />} label="Remember Me" />
                {hasError && <Alert icon={<Warning></Warning>} severity="warning" sx={{ marginBottom: 3 }}>{Utils.isNullOrEmpty(message)}{message}</Alert>}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Link href="/forgot-password" variant="body2" color="error" sx={{ textDecoration: "none" }}>Forgot password?</Link>
                    <Button variant="contained" onClick={onSignIn} size="large" color="error">Sign in</Button>
                </Box>
            </Card>
        </Container>
    );
}